import { FuelListCard } from './FuelListCard'

export const Component = { FuelListCard }